import { FC } from "react";
import { IAccountingFinalizationTimeStats } from "../../../models/statistcs/respons";
import OrderStatusStatsCard from "../order-status-stats-card";

interface IProps {
  stats?: IAccountingFinalizationTimeStats;
  onChange: (stats: IAccountingFinalizationTimeStats) => void;
  hideDateControls?: boolean;
}

const timeColumns = [
  { labelKey: "orders", field: "orderCount", width: 110 },
  {
    labelKey: "average",
    field: "averageAccountingMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "median",
    field: "medianAccountingMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "p90",
    field: "p90AccountingMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "p95",
    field: "p95AccountingMinutes",
    format: "minutes" as const,
    width: 140,
  },
  {
    labelKey: "max_label",
    field: "maxAccountingMinutes",
    format: "minutes" as const,
    width: 140,
  },
];

const AccountingFinalizationTimeStats: FC<IProps> = ({
  stats,
  onChange,
  hideDateControls,
}) => (
  <OrderStatusStatsCard
    stats={stats}
    onChange={onChange}
    hideDateControls={hideDateControls}
    titleKey="accounting_finalization_time_stats"
    averageLabelKey="average_accounting_finalization_time"
    averageField="averageAccountingMinutes"
    includedField="trackedAccountingOrderCount"
    includedLabelKey="tracked_accounting_orders"
    excludedField="excludedOrderCount"
    excludedTooltipKey="excluded_accounting_finalization_orders_tooltip"
    metrics={[
      {
        labelKey: "candidate_completed_orders",
        field: "candidateCompletedOrderCount",
      },
      {
        labelKey: "merged_with_driver_search",
        field: "mergedWithDriverSearchCount",
      },
      { labelKey: "median", field: "medianAccountingMinutes", format: "minutes" },
      { labelKey: "p90", field: "p90AccountingMinutes", format: "minutes" },
      { labelKey: "p95", field: "p95AccountingMinutes", format: "minutes" },
      {
        labelKey: "missing_accounting_finished_by",
        field: "missingAccountingFinishedByCount",
      },
      {
        labelKey: "missing_accounting_finished_at",
        field: "missingAccountingFinishedAtCount",
      },
    ]}
    tables={[
      {
        key: "accountants",
        labelKey: "accountants",
        rows: (value) => value.accountants || [],
        rowKey: (row, index) => `accountant-${row.accountantId ?? index}`,
        columns: [
          { labelKey: "accountant", field: "accountantName", width: 220 },
          ...timeColumns,
        ],
      },
      {
        key: "areas",
        labelKey: "areas",
        rows: (value) => value.areas || [],
        rowKey: (row, index) => `area-${row.areaId ?? index}`,
        columns: [
          { labelKey: "area", field: "areaName", width: 220 },
          ...timeColumns,
        ],
      },
    ]}
  />
);

export default AccountingFinalizationTimeStats;
